const ADOBE_TOPICS = {
    ADOBE_EVENT: 'ADOBE.TOPICS.ADOBE_EVENT',
    RESUME_TRACKING: 'ADOBE.TOPICS.RESUME_TRACKING',
    NEXT_ACCORDION: 'ADOBE.TOPICS.NEXT_ACCORDION',
    QUOTE_FIELD_ERROR: 'ADOBE.TOPICS.QUOTE_FIELD_ERROR',
    PAGE_URL: 'ADOBE.TOPICS.PAGE_URL',
    RESET: 'ADOBE.TOPICS.RESET',
    ADDON_CHANGE: 'ADOBE.TOPICS.ADDON_CHANGE',
    SUBMISSION_QUOTED: 'ADOBE.TOPICS.SUBMISSION_QUOTED',
    MEMBERSHIP: 'ADOBE.TOPICS.MEMBERSHIP',
    PREMIUM_ACCORDION: 'ADOBE.TOPICS.PREMIUM_ACCORDION',
    ERROR_PAGE: 'ADOBE.TOPICS.ERROR_PAGE',
    CUSTOMER_PERMISSIONS: 'CUSTOMER_PERMISSIONS',
    // MOTOR Specific
    VEHICLE_LOOKUP_TRACKING: 'ADOBE.TOPICS.VEHICLE_LOOKUP_TRACKING',
    MODIFICATION_CHANGE: 'ADOBE.TOPICS.MODIFICATION_CHANGE',
    CLAIMS_CHANGE: 'ADOBE.TOPICS.CLAIMS_CHANGE',
    // CEP specific
    SELF_SERVE_PRODUCTS: 'SELF_SERVE_PRODUCTS',
    FILTER_JOURNEY_PRODUCT: 'FILTER_JOURNEY_PRODUCT',
    MTA_CHANGES: 'MTA_CHANGES',
    RENEWAL_CHANGES: 'RENEWAL_CHANGES',
    UPDATE_JOURNEY_PRODUCT: 'UPDATE_JOURNEY_PRODUCT',
    PAGE_NAME: 'PAGE_NAME',
    CONTACT_US_PAGE: 'CONTACT_US_PAGE',
    // HOME Specific
    PROPERTY_DETAILS_TRACKING: 'ADOBE.TOPICS.PROPERTY_DETAILS_TRACKING',
    SET_PRODUCT_DETAILS: 'ADOBE.TOPICS.SET_PRODUCT_DETAILS',
    COMMUNICATION_PREFERENCES: 'COMMUNICATION_PREFERENCES',
    // TRAVEL Specific
    TRAVEL_PREMIUM_VALUES: 'TRAVEL_PREMIUM_VALUES',
    TRAVEL_TRIP_SWITCH: 'TRAVEL_TRIP_SWITCH'
};

export default ADOBE_TOPICS;
